import React from 'react'

export default function Notify() {
  return (
    <div>Notify</div>
  )
}
